"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabelsContainer = exports.StyledBarIndicator = exports.StyledProgressBarContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: baseline;\n  padding-top: ", ";\n  justify-content: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", "%;\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  animation: ", " 1s ease-in-out forwards;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        from {\n            width: 0;\n        }\n        to {\n            width: ", "%;\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ProgressAnimation = function ProgressAnimation(props) {
  return (0, _styledComponents.keyframes)(_templateObject(), props.value);
};

var StyledProgressBarContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.containerColor || props.theme.colors.brandThemeLight100;
}, function (props) {
  return props.radius || props.theme.graphs.progressBar.radius;
});

exports.StyledProgressBarContainer = StyledProgressBarContainer;

var StyledBarIndicator = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.value;
}, function (props) {
  return props.height || props.theme.graphs.progressBar.height;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.radius || props.theme.graphs.progressBar.radius;
}, function (props) {
  return ProgressAnimation(props);
});

exports.StyledBarIndicator = StyledBarIndicator;

var StyledLabelsContainer = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.labelPaddingTop || '5px';
}, function (props) {
  return props.justifyLabels;
});

exports.StyledLabelsContainer = StyledLabelsContainer;